import { render, staticRenderFns } from "./true-false-question.vue?vue&type=template&id=0a99227c&scoped=true"
import script from "./true-false-question.vue?vue&type=script&lang=js"
export * from "./true-false-question.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a99227c",
  null
  
)

export default component.exports